import axios from 'axios';
import { user } from '../store';
import apiClientConfig from './config';

const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: 'wa',
  plat_name: '51wj'
};

const MP_PLATFORM = {
  plat: 'wp',
  plat_name: '51wj'
};




export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = user.token;

  const response = await axios(url, {
    data,
    headers: {
      token
      // token: 2
    },
    method,
    params
  });
  if (response.data.status === 80003 || response.data.code === -301) {
    user.login();
  }

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

function createSaleClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.SALE_API + url, defaultData, defaultConfig);
}

function createMClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.API_PATH + url, defaultData, defaultConfig);
}



const apiClient = {
  base: {
    profile: createMClient('POST', '/api/user/profile' ),
    vipInfo: createMClient('GET', '/api/user/vip-info' ),
    vipList: createBaseClient('GET', '/v1/vip', {...MP_PLATFORM, action: 'list'} ),
    buyVip: createBaseClient('GET', '/v1/vip', MP_PLATFORM ),



    // 0015 - 微信签名
    weixinSign: createBaseClient('GET', '/v1/weixin', MP_PLATFORM),
    // 0066 - 登录
    login: createBaseClient('POST', '/v1/member', { action: 'login' }),
    // 0011.2 - 授权登录
    oauth: ({ route = '', mp = '' } = { route: '', mp: '' }) => {
      // 记录用户进行了 oauth 操作，以便后续决定是否要接受 token
      localStorage.setItem('oauth', 'true');

      const host = route
        ? window.location.host + route
        : window.location.host + window.location.pathname;

      let plat = '';
      let platName = '';

      if (mp) {
        plat = 'wp';
        platName = mp;
      }

      const url =
        API.OAUTH_URL +
        `?host=${encodeURIComponent(host)}&plat_name=${platName}&plat=${plat}`;

      window.location.href = url;
    },





    /** sale **/

    /**
     * 0011-快捷导入
     * content, sid, imgs, video
    **/
    pubCarFast: createSaleClient('POST', '/v1/car', {action: 'fast'} ),
  }
};

export default apiClient;
